import { Directive, Inject, Renderer2, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
  ValidationErrors,
} from '@angular/forms';
import { AppConfig } from '../../app.config';
import { Router, ActivatedRoute } from '@angular/router';
import { Session} from '../../common/entity/entities';
import { LocalStorage } from '../../common/decorators/decorators';
import { BrowserStorage } from '../../common/utils/tools';
import { SecurityHelper } from './helper/security.helper';
import { SecurityClient } from '../../client/security.client';
import { DOCUMENT } from '@angular/common';
import { ServiceStatusMessageTypes } from '../../common/entity/enum/serviceStatusMessages';
import { Subject } from 'rxjs';

@Directive()
export class BaseLoginComponent implements OnDestroy {
  user = new UntypedFormControl('', [Validators.required, startWithSpace()]);
  password = new UntypedFormControl('', [
    Validators.required,
    startWithSpace(),
  ]);
  form: UntypedFormGroup;
  progress: boolean = false;
  private destroy$ = new Subject<void>();

  @LocalStorage('grat_auth') public sessionObject;
  @LocalStorage('grat_menu') public menuObject;

  constructor(
    public route: ActivatedRoute,
    public config: AppConfig,
    public securityClient: SecurityClient,
    public router: Router,
    formBuilder: UntypedFormBuilder,
    public translate: TranslateService,
    public baseRenderer: Renderer2,
    @Inject(DOCUMENT) public _baseDocument: Document
  ) {
    BrowserStorage.useFor(this);
    this.form = formBuilder.group({
      user: this.user,
      password: this.password,
    });
  }

  ngOnInit() {
    this.translate.setDefaultLang('en');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Used for PAP login.
   */
  login(e?) {
    this.securityClient
      .login(
        this.user.value,
        this.password.value,
        this.translate.instant('login.SignInInProgress')
      )
      .then(
        (response) => {
          this.handleLogin(response);
        },
        (reject) => {
        }
      );
  }

  handleLogin(response: any) {
      this.sessionObject = response;
      Session.init(response);
      this.securityClient.reinitTokenHeader();
      
      SecurityHelper.getMenu(
          this.securityClient,
          this.router,
          this.translate.instant('login.AuthorizingUser')
      ).then((rejects) => {
          this.progress = false;
      });
      
      SecurityHelper.getActiveServiceStatusMessage(
          this.securityClient,
          ServiceStatusMessageTypes.ServiceStatusMessage
      ).then(
          (response) => {
              if (response?.result)
                  localStorage.setItem(`serviceStatusMessage_${Session.userCode}`, response.result);
          },
          (reject) => {
          });
      
      // Note: User notifications are now loaded by ReceivedNotificationsOverviewComponent
      // on component initialization. It will check Session first, then fetch from API if needed.
    }
}

export function startWithSpace(): (
  UntypedFormControl
) => ValidationErrors | null {
  return (control: UntypedFormControl): ValidationErrors | null => {
    return control?.value?.startsWith(' ') ? { startWithSpace: true } : null;
  };
}